import { resourcePredicate } from "@p0security/shared/assessment/dsl";
import { resourceReducers } from "@p0security/shared/assessment/reducers/resource";

import { resourceColumns } from "./columns";

export const resourceData = {
  predicate: resourcePredicate,
  reducers: resourceReducers,
  columns: resourceColumns,
};
